import { createSelector } from 'reselect';
import { EDITION_NAMES } from '../constants/editions';

export const getEdition = (state) => state.edition.edition;

export const getEditionName = createSelector(
    getEdition,
    (edition) => EDITION_NAMES[edition],
);
